// Polyfills, patches, config, plugins and helpers
require("./patches.js");
require("./jqueryplugins.js");
require("./emoji.js");
require("./emoji-data.js");
require("./emojiconf.js");
require('./consolehelpers.js');



//////////////////
// WEBPACK FOOTER
// ./app/src/lib/setup.js
// module id = 1Cb+
// module chunks = 1